import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import { FIELD_TYPES } from '../../constants';
import { useError } from '../../field-error';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { getTextInputFieldError } from '../text-input-field/text-input-field-utils';
import { SignatureDrawerWUT } from './drawer/signature-drawer-wut';
import { SignatureFooterWUT } from './footer/signature-footer-wut';
import { classes } from './stylesheets/signature.st.css';
import { useSignatureValue } from './hooks/use-signature-value';
import { FORM_STATUS, useFormStatus } from '../../contexts/form-status-provider';
export function SignatureFieldWUT(props) {
  const {
    id,
    required,
    label,
    hideLabel,
    target,
    description,
    uploadEnabled,
    FieldLayout,
    validation,
    error,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    value,
    onBlur,
    onChange,
    ...rest
  } = props;
  const {
    errorMessage,
    hasError
  } = useError(getTextInputFieldError(validation, error), undefined, FIELD_TYPES.SIGNATURE, uploadEnabled ? 'with-upload' : undefined);
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const {
    signature,
    handleChange,
    cancelUpload
  } = useSignatureValue({
    value,
    onChange,
    target
  });
  const {
    setFormStatus
  } = useFormStatus();
  const handleBeforeChange = useCallback(() => {
    cancelUpload();
    setFormStatus(target, FORM_STATUS.BUSY);
  }, [cancelUpload, setFormStatus, target]);
  const handleBlur = ev => {
    var _nextFocusedElement$d;
    const nextFocusedElement = ev.relatedTarget;
    const nextFocusedElementId = nextFocusedElement == null || (_nextFocusedElement$d = nextFocusedElement.dataset) == null ? void 0 : _nextFocusedElement$d.inputId;
    if (nextFocusedElementId !== inputId) {
      onBlur();
    }
  };
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(SignatureDrawerWUT, _extends({
      target: target,
      inputId: inputId,
      fieldId: id,
      ariaLabelledBy: labelId,
      ariaDescribedBy: ariaDescribedBy,
      hasError: hasError,
      onChange: handleChange,
      value: signature,
      onBlur: handleBlur,
      required: required,
      handleBeforeChange: handleBeforeChange
    }, rest)),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.footer
    }, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      id: errorId,
      target: target,
      hasError: hasError,
      errorMessage: errorMessage
    }), /*#__PURE__*/React.createElement(SignatureFooterWUT, {
      value: signature,
      enableUpload: uploadEnabled,
      onChange: handleChange,
      onBlur: onBlur,
      inputId: inputId,
      cancelUpload: cancelUpload,
      target: target
    })), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
}
//# sourceMappingURL=signature-field-wut.js.map